export default __webpack_public_path__ + "static/media/para_r_5302_bp.44dae2ec.svg";